// @ts-nocheck
import React, { Component } from 'react';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { observer, inject } from "../../../../../stores/mobx-compat";

// Stripe Elements renders in a cross-origin iframe, so it can't inherit our
// CSS variables. Resolve the theme tokens to concrete values at render time
// and rebuild whenever <html data-theme> changes.
const readVar = (name, fallback) => {
  if (typeof window === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

const buildElementOptions = () => ({
  style: {
    base: {
      color: readVar('--mov-ink', '#14181a'),
      fontFamily: '"Inter Tight", system-ui, sans-serif',
      fontSize: '14px',
      fontSmoothing: 'antialiased',
      iconColor: readVar('--mov-ink-soft', '#5a625f'),
      '::placeholder': { color: readVar('--mov-ink-mute', '#8a918c') },
    },
    invalid: { color: '#ea3546', iconColor: '#ea3546' },
  },
});

class InjectedCardSection extends Component {
  state = { elementOptions: buildElementOptions() };

  componentDidMount() {
    if (typeof MutationObserver === 'undefined') return;
    this.themeObserver = new MutationObserver(() => {
      this.setState({ elementOptions: buildElementOptions() });
    });
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });
  }

  componentWillUnmount() {
    if (this.themeObserver) this.themeObserver.disconnect();
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const cardElement = this.props.elements.getElement(CardElement);
    const token = await this.props.stripe.createToken(cardElement);
    if (token.error) {
      this.props.store.failure(token.error.message);
      this.props.store.payments.stripeToken = {};
    } else if (token) {
      this.props.store.payments.stripeToken = token.token;
    }
    if (!this.props.store.accountStatus.account.default_source) {
      this.props.store.payments.confirmPaymentAndSubscribe();
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div
          style={{
            background: 'var(--mov-paper-2)',
            border: '1px solid var(--mov-line-strong)',
            borderRadius: 10,
            padding: '12px 14px',
          }}
        >
          <CardElement options={this.state.elementOptions} />
        </div>
        <button
          type="submit"
          style={{ display: 'none' }}
          ref={(c) => { this.props.store.payments.setConfirmPaymentsRef(c); }}
        />
      </form>
    );
  }
}

const WrappedInjectedCardSection = inject('store')(observer(InjectedCardSection));

const InjectedCardSectionWithStripe = (props) => (
  <ElementsConsumer>
    {({ stripe, elements }) => <WrappedInjectedCardSection {...props} stripe={stripe} elements={elements} />}
  </ElementsConsumer>
);

export default InjectedCardSectionWithStripe;
